import React, {FC} from 'react';
import styled from 'styled-components';
import {BannerTitle} from './BannerTitle';
import {BannerFlexLink} from '../../atoms/Banner/BannerFlexLink';

interface CampaignTopBannerTitleProps {
  title: string;
  superText?: string;
  bannerLink?: string;
  reduced?: boolean;
  className?: string;
}

export const CampaignBannerTitle: FC<CampaignTopBannerTitleProps> = ({
  title,
  superText,
  bannerLink,
  reduced,
  className,
}) => {
  if (title.length === 0) {
    return null;
  }
  return (
    <Container
      to={bannerLink}
      id="campaign-top-banner-title"
      data-testid="campaign-top-banner-title-wrapper"
      as={bannerLink ? BannerFlexLink : 'div'}
    >
      <BannerTitle
        boldTitle={!reduced}
        title={title}
        superText={superText}
        bannerAlignment="center"
        defaultSize={reduced ? 'px12' : 'px18'}
        className={className}
      />
    </Container>
  );
};

export const Container = styled.div<{
  to: string | undefined;
}>``;
